import { X } from 'lucide-react'

export default function DetalleProductoModal({ 
  producto, 
  fecha, 
  datosClientes, 
  onClose 
}) {
  if (!producto || !datosClientes) return null

  // Filtrar y ordenar clientes por devoluciones de este producto
  const clientesConDevoluciones = datosClientes
    .filter(c => c.devuelto > 0)
    .sort((a, b) => parseFloat(b.porcentajeDev) - parseFloat(a.porcentajeDev))
    .slice(0, 5) // Top 5

  const clientesSinDevoluciones = datosClientes.filter(c => c.devuelto === 0).length

  const totalEntregado = datosClientes.reduce((sum, c) => sum + c.entregado, 0)
  const totalDevuelto = datosClientes.reduce((sum, c) => sum + c.devuelto, 0)
  const porcentajeTotal = totalEntregado > 0 
    ? ((totalDevuelto / totalEntregado) * 100).toFixed(1) 
    : 0

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'var(--bg)',
          borderRadius: '12px',
          width: '90%',
          maxWidth: '600px',
          maxHeight: '80vh',
          overflow: 'auto'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '1.5rem',
          borderBottom: '1px solid var(--border)'
        }}>
          <div>
            <h2 style={{ margin: 0, marginBottom: '0.5rem' }}>
              🔍 {producto}
            </h2>
            <div style={{ fontSize: '0.875rem', color: 'var(--muted)' }}>
              {new Date(fecha + 'T00:00:00').toLocaleDateString('es-ES', { 
                weekday: 'long', 
                day: 'numeric', 
                month: 'long',
                year: 'numeric'
              })}
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            <X size={24} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.5rem' }}>
          {/* Resumen total */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1rem',
            marginBottom: '1.5rem',
            padding: '1rem',
            background: 'var(--bg-secondary)',
            borderRadius: '8px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '0.75rem', color: 'var(--muted)', marginBottom: '0.25rem' }}>
                Total Entregado
              </div>
              <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                {totalEntregado} ud
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '0.75rem', color: 'var(--muted)', marginBottom: '0.25rem' }}>
                Total Devuelto
              </div>
              <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--warn)' }}>
                {totalDevuelto} ud
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '0.75rem', color: 'var(--muted)', marginBottom: '0.25rem' }}>
                % Devolución
              </div>
              <div style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'bold',
                color: parseFloat(porcentajeTotal) > 12 ? 'var(--warn)' : 
                       parseFloat(porcentajeTotal) > 8 ? '#f59e0b' : '#10b981'
              }}>
                {porcentajeTotal}%
              </div>
            </div>
          </div>

          {/* Top 5 clientes */}
          {clientesConDevoluciones.length > 0 ? (
            <>
              <h3 style={{ marginBottom: '1rem', fontSize: '1rem' }}>
                👥 Clientes con más devoluciones
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {clientesConDevoluciones.map((cliente, idx) => (
                  <div
                    key={idx}
                    style={{
                      padding: '1rem',
                      background: 'var(--bg-secondary)',
                      borderRadius: '8px',
                      border: parseFloat(cliente.porcentajeDev) > 15 
                        ? '2px solid var(--warn)' 
                        : '1px solid var(--border)'
                    }}
                  >
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between',
                      marginBottom: '0.5rem'
                    }}>
                      <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                        {idx + 1}º {cliente.nombre}
                      </div>
                      <div style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '6px',
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                        background: parseFloat(cliente.porcentajeDev) > 15 
                          ? 'rgba(239, 68, 68, 0.2)'
                          : parseFloat(cliente.porcentajeDev) > 10
                          ? 'rgba(245, 158, 11, 0.2)'
                          : 'rgba(16, 185, 129, 0.2)',
                        color: parseFloat(cliente.porcentajeDev) > 15
                          ? 'var(--warn)'
                          : parseFloat(cliente.porcentajeDev) > 10
                          ? '#f59e0b'
                          : '#10b981'
                      }}>
                        {cliente.porcentajeDev}% dev
                      </div>
                    </div>
                    
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      marginBottom: '0.5rem'
                    }}>
                      <div>
                        <span style={{ color: 'var(--muted)' }}>Entregado:</span>
                        <strong> {cliente.entregado} ud</strong>
                      </div>
                      <div>
                        <span style={{ color: 'var(--muted)' }}>Devuelto:</span>
                        <strong style={{ color: 'var(--warn)' }}> {cliente.devuelto} ud</strong>
                      </div>
                      <div>
                        <span style={{ color: 'var(--muted)' }}>Neto:</span>
                        <strong> {cliente.entregado - cliente.devuelto} ud</strong>
                      </div>
                    </div>

                    {parseFloat(cliente.porcentajeDev) > 10 && (
                      <div style={{
                        marginTop: '0.5rem',
                        padding: '0.5rem',
                        background: 'rgba(59, 130, 246, 0.1)',
                        borderRadius: '4px',
                        fontSize: '0.875rem',
                        color: 'var(--accent)'
                      }}>
                        💡 Sugerencia: Reducir {cliente.devuelto} unidades
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div style={{
              padding: '2rem',
              textAlign: 'center',
              color: 'var(--muted)'
            }}>
              ✅ No hubo devoluciones de este producto
            </div>
          )}

          {/* Footer - Clientes sin devoluciones */}
          {clientesSinDevoluciones > 0 && (
            <div style={{
              marginTop: '1.5rem',
              padding: '1rem',
              background: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid #10b981',
              borderRadius: '8px',
              fontSize: '0.875rem',
              textAlign: 'center',
              color: '#10b981'
            }}>
              ✅ {clientesSinDevoluciones} cliente{clientesSinDevoluciones !== 1 ? 's' : ''} sin devoluciones
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '1.5rem',
          borderTop: '1px solid var(--border)'
        }}>
          <button
            onClick={onClose}
            className="btn-primary"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}